function PendingEmptyState() {
    return (
        <div className='flex flex-col items-center justify-center gap-2 text-center text-[#9e9e9e]'>
            <div className='text-lg font-semibold'>No device yet.</div>
            <div className='flex items-center text-lg font-semibold'>
                <span className='pr-1'>Tap </span>
                <img src='/add_circle.png' alt='' className='w-4 h-4' />
                <span className='pl-1'> to add more</span>
            </div>
        </div>
    );
}

export default PendingEmptyState;
